import { GESTION_OPERATIVA_SET_SPECIAL_BON_EDITABLE } from './constants'

export function setSpecialBonEditable(bool) {

    return (dispatch) =>{
      dispatch({
      type: GESTION_OPERATIVA_SET_SPECIAL_BON_EDITABLE,
      data: { isSpecialBonEditable: bool }
      })
  };
}

export function reducer(state, action) {
  if (action.type === GESTION_OPERATIVA_SET_SPECIAL_BON_EDITABLE) {
      return {
        ...state,
        isSpecialBonEditable: action.data.isSpecialBonEditable
        }
  }
  else{
    return state
  }
}
